<script>
import searchForm from '@/components/search-form.vue'

export default {
  name: 'hero-home',
  components: {
    searchForm,
  },
  computed: {
    vuetify() {
      return this.$vuetify
    },
  },
}
</script>
<template>
  <v-sheet
    width="100%"
    class="hero d-flex flex-column align-center justify-center pa-4"
    :style="{
      height: `calc(90vh - ${$vuetify.application.top}px)`,
      'background-position': $vuetify.breakpoint.lgAndUp
        ? 'center -10px'
        : 'center -10px',
      'background-size': $vuetify.breakpoint.lgAndDown ? 'cover' : '',
    }"
  >
    <!-- 'background-position': $vuetify.breakpoint.lgAndUp ? 'center -50px' : $vuetify.breakpoint.mdAndDown ? 'center -50px' : '', -->
    <!-- <v-sheet class="hero d-flex flex-column align-center justify-center pa-4" :style="{ height: `calc(105vh - ${$vuetify.application.top}px)` }"> -->
    <v-sheet color="transparent" class="content-container">
      <h1
        class="text-h2 hero-title font-weight-black secondary--text mt-2 textStroke"
        style="position: relative; z-index: 2"
      >
        East Islip Public Library
      </h1>
      <h2 class="text-h6 hero-sub-title secondary--text textStrokeSmall mb-4">
        The Resource Center For Lifelong Learning
      </h2>
      <search-form :inputProps="{ 'hide-details': true }" />
    </v-sheet>
  </v-sheet>
</template>

<style scoped>
.content-container {
  max-width: 1200px;
}
.hero {
  background-attachment: fixed;
  background-color: #000066;
  background-image: url('https://media.eipl.org/site/images/building/EIPL_Spring.jpg');
  background-position: center -50px;
  /* background-position: center 150px; */
  background-size: 100%;
  /* background-size: cover; */
}
.hero-title,
.hero-sub-title {
  letter-spacing: 0.25ch !important;
  text-shadow: 4px 5px 6px rgba(0, 0, 0, 0.6);
}

.textStroke {
  text-shadow: -1px 1px 0 var(--v-secondary-base),
    1px 1px 0 var(--v-secondary-base), 4px 5px 6px var(--v-primary-base);
  /* background: rgb(0, 0, 0, 0.25); */
}
.textStrokeSmall {
  /* text-shadow: -0.5px -0.5px 0 var(--v-secondary-base), 0.5px -0.5px 0 var(--v-secondary-base), -0.5px 0.5px 0 var(--v-secondary-base), 0.5px 0.5px 0 var(--v-secondary-base),
      2px 3px 4px var(--v-secondary-base); */
  text-shadow: 4px 5px 6px var(--v-primary-base);
}
</style>
